import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';

import { MediaBP as MQ } from '../../styles/mediaQuery';

export const LegalPageContainerStyle = css`
  position: relative;
  width: 100%;
  padding: 30px 50px;
  min-height: calc(100vh - 108px);
  ${MQ.MediaMd} {
    min-height: calc(100vh - 80px);
  }
  ${MQ.MediaSmRange} {
    padding: 20px 20px;
  }
  color: ${colors.white};
`;

export const legalPageSpacing = css`
  margin: 10px 0px;
`;

export const scrollableContainer = css`
  overflow-x: auto; /* Enable horizontal scrolling */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */
  border: 1px solid #ccc; /* Optional border for visual distinction */
  border-radius: 8px; /* Optional rounded corners */
`;

export const tableStyles = css`
  border-collapse: collapse;
  width: 100%; /* Ensure the table spans the container */
  min-width: 600px; /* Enforce a minimum width for readability */

  th,
  td {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
  }
`;

export const StepsWrapper = css`
  padding: 20px 0px;
  p {
    margin-top: 12px;
  }
`;
